jQuery(document).ready(function() {
  console.log('ready !');

  jQuery('.product-details .abz-bean-img img').attr('alt','grading image');
  
  setTimeout(function(){
       jQuery('img').each(function(index) {
          if(!jQuery(this).attr('alt')){
            jQuery(this).attr('alt','product image');
          }
       });
       jQuery('span.flatpickr-day').attr('role','status');
       jQuery('.slick-slide').removeAttr('role');
       jQuery('.slick-track').removeAttr('role').removeAttr('aria-label');
       jQuery('#gf-tree button.gf-controls-search-button').append('<span class="sr-only">search button</span>');
       jQuery('#gf-tree button.gf-controls-clear-button').append('<span class="sr-only">clear button</span>'); 
       jQuery('div#shopify-section-template--22271283134761__170011365362eb3e27 .bcontact-title').remove();
       jQuery('div#shopify-section-template--22271283134761__170011365362eb3e27 .bcontact-title').remove();
       jQuery('div#shopify-block-5af55afc-b1ab-46b0-ad95-0767bf1a755c .bcontact-title, div#shopify-block-b32975ff-10c5-4c74-ad10-a91a1fd3b3ff .bcontact-title').removeAttr('aria-label');
       
    }, 100);

      initMainMenu();
      var windowSize = jQuery(window).width(); 
      window.addEventListener("resize", getWindowSize); 
    
      function getWindowSize() {
        windowSize = jQuery(window).width();
      }
    
      function initMainMenu() {
        var mainMenu = document.querySelector('.main-nav ul');
    
        // keyboard stuff 
        jQuery(mainMenu).delegate('li a', 'keydown', keyboardHandler); 
        
        } 
    
      function keyboardHandler(keyVent) {
        var target = keyVent.target;
        var which = keyVent.which;
    
        if (which === 39) { // RIGHT 
    
            if (isTopLevel(target)) {
              // top level item 
    
                var nextTopItem = adjacentTopLevelItem(target, 'next');
                if (nextTopItem) {
                  keyVent.preventDefault();
                  nextTopItem.focus();
                } 
    
          } else { 
            // dropdown item 
            var nextDropletItem = adjacentDropdownItem(target, 'next'); 
    
              if (nextDropletItem) {
                  keyVent.preventDefault(); 
                  nextDropletItem.focus(); 
    
              }
            }
          } else if (which === 37) { // LEFT 
                if (isTopLevel(target)) {
                  // top level item 
                var prevTopItem = adjacentTopLevelItem(target, 'prev'); 
    
                if (prevTopItem) { 
                    keyVent.preventDefault(); 
                    prevTopItem.focus(); 
    
            } 
            } else { 
            // dropdown item 
            var prevDropItem = adjacentDropdownItem(target, 'prev'); 
            if (prevDropItem) { 
              keyVent.preventDefault(); 
              prevDropItem.focus(); 
    
              } 
            } 
    
          } else if (which === 40) { // DOWN 
                  if (isTopLevel(target) && hasDropdown(target)) { 
                  // top level item w/ dropdown -- open dropdown 
                  openDropdown(target); 
    
          } else { 
          // dropdown item 
          var nextDropItem = adjacentDropdownItem(target, 'next'); 
          if (nextDropItem) { 
              keyVent.preventDefault();
              nextDropItem.focus(); 
            }
          }
    
          } else if (which === 38) { // UP
                if (!isTopLevel(target)) {
                  console.log('inside drop');
                    if (isFirstDropItem(target)) { 
                      keyVent.preventDefault(); 
                      var top = closeDropdown(target); 
                      setTimeout(function() { 
                        top.focus(); 
                    }, 0); 
    
          } else { 
    
            var prevDropAnchor = adjacentDropdownItem(target, 'prev');
            if (prevDropAnchor) {
              keyVent.preventDefault();
              prevDropAnchor.focus(); 
            }
          }
        }
    
        } else if (which === 27) { // ESCAPE 
    
            if (!isTopLevel(target)) { 
    
              var topper = closeDropdown(target); 
    
              setTimeout(function() { 
    
                topper.focus(); 
    
            }, 0); 
    
          } 
    
          } else if (which === 9 && keyVent.shiftKey) { // SHIFT + TAB 
    
              if (!isTopLevel(target) && isFirstDropItem(target)) { 
    
                  keyVent.preventDefault(); 
    
                  var topA = closeDropdown(target); 
    
                  setTimeout(function() { 
    
                      topA.focus(); 
    
                  }, 0); 
    
          } 
    
          } else if (which === 9) { // TAB 
    
          if (!isTopLevel(target) && isLastDropItem(target)) { 
    
              keyVent.preventDefault();
              var topItem = closeDropdown(target); 
              var nextLi = jQuery(topItem.parentNode).next()[0]; 
              var nextAnchor = jQuery('a', nextLi)[0]; 
              nextAnchor.focus(); 
    
          }
    
      } else if (which === 32) { // Space 
    
          if (isTopLevel(target) && jQuery(target.parentNode).hasClass('dropdown')) { 
    
            openDropdown(target); 
    
        } 
    
      } 
    
    }										 
    
    // determines if the item is a top-level one 
    function isTopLevel(item) {
      return jQuery(item).is('.main-nav > ul > li > a'); 
    } 
    
    // determines if the item has a dropdown 
    function hasDropdown(item) {
      return jQuery(item.parentNode).hasClass('dropdown');
    } 
    
    // determines if the item is the first in the dropdown
    function isFirstDropItem(item) {
        console.log('first drop item');
        var drop = jQuery(item).closest('.sub-nav')[0];
        var firstInDrop = jQuery('li a', drop)[0];
        return firstInDrop === item;
    } 
    
    // determines if the item is the last in the dropdown 
    function isLastDropItem(item) {
      var drop = jQuery(item).closest('.sub-nav')[0];
      var lastInDrop = jQuery('li a', drop).last()[0];
      return lastInDrop === item;
    }
  
    // finds the adjacent top level item
    function adjacentTopLevelItem(item, dir) {
      var li = item.parentNode; // <li /> 
      var adjacentLi = (dir === 'next') ? jQuery(li).next()[0] : jQuery(li).prev()[0];
      var adjacentItem = adjacentLi && jQuery('a', adjacentLi)[0];
      return adjacentItem;
    } 
    
    // finds the next or prev dropdown item 
    
    function adjacentDropdownItem(item, dir) { 
    
      var adjacentDropItem; 
    
      var li = item.parentNode; 
    
      var adjacentSameCol = (dir === 'next') ? jQuery(li).next()[0] : jQuery(li).prev()[0]; 
    
      if (adjacentSameCol) { 
    
    // there is one in the same col 
    
    adjacentDropItem = jQuery('a', adjacentSameCol)[0]; 
    
    } else { 
    
    // lets look for one in the adjacent column 
    
    var col = jQuery(li).closest('.col')[0]; 
    
    var adjacentCol = (dir === 'next') ? jQuery(col).next()[0] : jQuery(col).prev()[0]; 
    
    if (adjacentCol) { 
    
    // we've found the adjacent column 
    
    var adjacentItem = (dir === 'next') ? jQuery('li a', adjacentCol)[0] : jQuery('li a', adjacentCol).last()[0]; 
    
    if (adjacentItem) { 
    
    adjacentDropItem = adjacentItem; 
    
    } 
    
    } 
    
    } 
    
    return adjacentDropItem; 
    
    } 
    function openDropdown(item) { 
        jQuery(item.parentNode).addClass('active');
        var droplet = jQuery(item).next()[0]; 
        console.log(droplet);
        jQuery(droplet).attr("aria-hidden", "false");
        // open the dropdown... 
        jQuery(droplet).css({"opacity": "1", "visibility": "visible"});
    
        // ...and focus the first item 
    
        setTimeout(function() { 
          jQuery('a', droplet)[0].focus(); 
        }, 100);
    }
    function closeDropdown(item) {
        var droplet = jQuery(item).closest('.sub-nav')[0];
        console.log(droplet);
        jQuery(droplet).attr("aria-hidden", "true");
        var topLevelItem = jQuery(droplet).prev()[0];
        jQuery(topLevelItem).attr("aria-expanded", "false");
        jQuery(topLevelItem.parentNode).removeClass('active');
        jQuery(droplet).css({"opacity": "0", "visibility": "hidden"});
      return topLevelItem; 
    
    } 
    
});
